import { render, staticRenderFns } from "./MatrixPrickerItem.vue?vue&type=template&id=cd145b6e&scoped=true"
import script from "./MatrixPrickerItem.vue?vue&type=script&lang=ts"
export * from "./MatrixPrickerItem.vue?vue&type=script&lang=ts"
import style0 from "./MatrixPrickerItem.vue?vue&type=style&index=0&id=cd145b6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd145b6e",
  null
  
)

export default component.exports